import { useSyncExternalStore } from "react";
import { getLibMode, subscribeLibMode } from "@/lib/api";

export const useLibMode = () => useSyncExternalStore(subscribeLibMode, getLibMode);
